import React, { useCallback, useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import config from "../config";
import { UserContext } from "../components/MyContext";
import "bootstrap/dist/css/bootstrap.min.css";
import AppShell from "../components/AppShell";

export default function DownloadFile() {
  const { userData } = useContext(UserContext);
  const [fileDownload, setFileDownload] = useState([]);

  const fetchDataPeriod = useCallback(async () => {
    try {
      const resFiles = await axios.get(`${config.urlApi}/manageFile`);
      setFileDownload(resFiles.data);
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: e.message,
      });
    }
  }, []);

  useEffect(() => {
    fetchDataPeriod();
  }, [fetchDataPeriod]);

  const handleDownload = async (fileName) => {
    if (!fileName) {
      Swal.fire("เกิดข้อผิดพลาด!", "ไม่มีชื่อไฟล์ที่จะดาวน์โหลด", "error");
      return;
    }

    try {
      const response = await axios.get(`${config.urlApi}/download/${fileName}`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error("Error downloading file:", error);
      Swal.fire("เกิดข้อผิดพลาด!", "ไม่สามารถดาวน์โหลดไฟล์ได้", "error");
    }
  };

  return (
    <AppShell
      page={'downloadFile'}
      contentPreset="document"
      title="ไฟล์เอกสาร"
      subtitle={`ดาวน์โหลดเอกสารสำหรับการดำเนินงานของหน่วยงาน ${userData.facultyName || '-'} ได้จากหมวดหมู่ด้านล่าง`}
    >
      <section className="section">
        <div className="accordion" id="accordionExample">
          {fileDownload.map((item, fileIndex) =>
            item.statue_active === '1' && (
              <div className="accordion-item" key={`file-${fileIndex}`}>
                <h2 className="accordion-header" id={`heading-${fileIndex}`}>
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${fileIndex}`}
                    aria-expanded="false"
                    aria-controls={`collapse-${fileIndex}`}
                  >
                    {item.categoryName || `${item.cate_name}`}
                  </button>
                </h2>
                <div
                  id={`collapse-${fileIndex}`}
                  className="accordion-collapse show"
                  aria-labelledby={`heading-${fileIndex}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {item.manage_files && item.manage_files.length > 0 ? (
                      <ul>
                        {item.manage_files.map((manage_file, manageIndex) =>
                          manage_file.status_active === '1' && (
                            <li key={`file-${fileIndex}-doc-${manageIndex}`}>
                              <button
                                type="button"
                                onClick={() => manage_file?.file_name && handleDownload(manage_file.file_name)}
                                className="btn btn-link text-decoration-none px-0"
                              >
                                {manage_file.file_detail + '.' + manage_file.file_type}
                              </button>
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <p>ไม่มีไฟล์ในหมวดนี้</p>
                    )}
                  </div>
                </div>
              </div>
            )
          )
          }
        </div>
      </section>
    </AppShell>
  );
}
